import {
    ClickElement,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

function trackProductItemClicked(label: string, url: string): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'ButtonClick',
            label,
            eventData: {
                eventName: GA4EventName.ClickButton,
                feature_category: GA4FeatureCategory.ProductdetailBuybox,
                click_element: ClickElement.PDPVariant,
                click_text: label,
                click_url: url,
            },
        });
    }, 0);
}

function trackDropDownOpened(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'Open',
            label: 'OptionsDropdown',
        });
    }, 0);
}

function trackDropdownClicked(label: string, eventName?: GA4EventName): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'DropdownClick',
            label,
            ...(eventName
                ? {
                      eventData: {
                          eventName: GA4EventName.SelectValueVoucherAmount,
                          feature_category: GA4FeatureCategory.ProductdetailBuybox,
                          selected_value: label,
                      },
                  }
                : {}),
        });
    }, 0);
}

export { trackDropdownClicked, trackDropDownOpened, trackProductItemClicked };
